import type { HolidayGridEvent } from 'modules/shift_management/utils/TimeGridTable/transformEvents'

import type { EventCardSpec } from 'modules/shift_management/utils/TimeGridTable/resolveCard'

const HolidayCard: EventCardSpec<HolidayGridEvent> = {
  getAppearance: () => ({
    background: 'purple200',
    opacity: '0.9',
    border: { all: { width: 's1', style: 'solid', color: 'champagne200' } },
  }),
  render: (event) => {
    return event.holiday.halfDay ? `½ ${event.holiday.summary}` : event.holiday.summary
  },
}

export { HolidayCard }
